import {UI} from "../../../stem-core/src/ui/UIBase";

import {PanelPage, PanelPageStyle} from "../PanelPage";
import {styleRule, styleRuleInherit} from "../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme";
import {Messages} from "../../Messages";
import {iFrameState} from "../../services/IFrameState";
import {merchantStyleRule} from "../Security";
import {DONATE_PAGE_URLS} from "../PanelConstants";
import {Switcher} from "../../../stem-core/src/ui/Switcher";
import {DonatePanel} from "./donate/DonatePanel";
import {InlineAuthPanel} from "./auth/InlineAuthPanel.jsx";
import {PayWithAddedCardPanel} from "./pay-with-card/PayWithAddedCardPanel";
import {ThankYouPanel} from "./thank-you/ThankYouPanel";
import {isSmallScreen} from "../../UtilsLib";
import {iFrameConnection} from "../../services/IFrameConnection";
import {IFrameMessages} from "../../../blink-sdk/messaging/IFrameMessages";
import {ThankYouMessageReceivedPanel} from "./thank-you-message-received/ThankYouMessageReceivedPanel";
import {RecurringDonorPanel} from "./recurring-donor/RecurringDonorPanel";
import {PayWithChosenCardPanel} from "./pay-with-chosen-card/PayWithChosenCardPanel";
import {EditDonationPanel} from "./edit-donation/EditDonationPanel";
import {DonationUpdatedPanel} from "./donation-updated/DonationUpdatedPanel";
import {EditChooseCardPanel} from "./edit-choose-card/EditChooseCardPanel";
import {EditAddCardPanel} from "./edit-add-card/EditAddCardPanel";
import {CancelDonationPanel} from "./cancel-donation/CancelDonationPanel";
import {DonationCanceledPanel} from "./donation-canceled/DonationCanceledPanel";
import {PaymentFailedPanel} from "./payment-failed/PaymentFailedPanel";
import {iFrameMerchantService} from "../../services/IframeMerchantService";
import {iFrameUserDataService} from "../../services/IFrameUserDataService";


class DonateHomePageStyle extends PanelPageStyle {
    @styleRuleInherit
    panelPage = {
        fontFamily: this.themeProps.DONATE_PAGE_FONT_FAMILY,
        color: this.themeProps.DONATE_PAGE_COLOR,
        width: "100%",
    };

    @styleRule
    title = {
        color: this.themeProps.DONATE_PAGE_COLOR,
        textAlign: () => isSmallScreen() ? "" : "center",
        fontSize: () => isSmallScreen() ? 24 : 30,
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
        marginBottom: () => isSmallScreen() ? 10 : 58,
    };

    @styleRule
    container = {
        display: "flex",
        justifyContent: "center",
        flexDirection: () => isSmallScreen() ? "column" : "row"
    };

    @merchantStyleRule
    paragraph = {
        color: this.themeProps.DONATE_PAGE_TEXT_COLOR,
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_LARGE,
        marginBottom: "24px",
        maxWidth: "410px",
        ...iFrameState.textStyle
    };

    @styleRule
    switcher = {
        height: "fit-content",
        width: 430,
        maxWidth: "100%",
        marginBottom: 20,
        marginRight: () => isSmallScreen() ? 0 : 50,
        padding: () => isSmallScreen() ? "20px" : "30px 40px",
        border: () => "1px solid " + this.themeProps.DONATE_PAGE_SWITCHER_BORDER_COLOR,
    };
}

@registerStyle(DonateHomePageStyle)
export class DonateHomePage extends PanelPage {
    constructor(...args) {
        super(...args);

        this.changeURL = this.changeURL.bind(this);
    }

    render() {
        const {styleSheet} = this;
        const publicationName = iFrameMerchantService.getMerchant().name;
        const title = iFrameState.title || Messages.donatePageTitle(publicationName);
        const text = iFrameState.panelText || "";
        const switcherStyle = text ? {} : {
            marginBottom: 0,
            marginRight: 0,
        }

        return [
            title ? <div className={styleSheet.title}>{title}</div> : null,
            <div className={styleSheet.container}>
                <Switcher lazyRender ref="switcher" className={styleSheet.switcher} style={switcherStyle}>
                    <DonatePanel changeURL={this.changeURL} ref={DONATE_PAGE_URLS.donate}/>
                    <RecurringDonorPanel changeURL={this.changeURL} ref={DONATE_PAGE_URLS.recurringDonor}/>
                    <EditDonationPanel changeURL={this.changeURL} ref={DONATE_PAGE_URLS.editDonation}/>
                    <InlineAuthPanel changeURL={this.changeURL} ref={DONATE_PAGE_URLS.auth}/>
                    <PayWithAddedCardPanel changeURL={this.changeURL} ref={DONATE_PAGE_URLS.payWithAddedCard}/>
                    <PayWithChosenCardPanel changeURL={this.changeURL} ref={DONATE_PAGE_URLS.payWithChosenCard}/>
                    <ThankYouPanel changeURL={this.changeURL} ref={DONATE_PAGE_URLS.thankYou}/>
                    <ThankYouMessageReceivedPanel changeURL={this.changeURL} ref={DONATE_PAGE_URLS.thankYouMessageReceived}/>
                    <DonationUpdatedPanel changeURL={this.changeURL} ref={DONATE_PAGE_URLS.donationUpdated}/>
                    <EditChooseCardPanel changeURL={this.changeURL} ref={DONATE_PAGE_URLS.editChooseCard}/>
                    <EditAddCardPanel changeURL={this.changeURL} ref={DONATE_PAGE_URLS.editAddCard}/>
                    <CancelDonationPanel changeURL={this.changeURL} ref={DONATE_PAGE_URLS.cancelDonation}/>
                    <DonationCanceledPanel changeURL={this.changeURL} ref={DONATE_PAGE_URLS.donationCanceled}/>
                    <PaymentFailedPanel changeURL={this.changeURL} ref={DONATE_PAGE_URLS.paymentFailed}/>
                </Switcher>
                <div>{text.split("\n").map(paragraph =>
                    <div className={styleSheet.paragraph}>{paragraph}</div>)}
                </div>
            </div>
        ];
    }

    changeURL = (url, forceRedraw=false) => {
        this.switcher.setActive(this[url]);
        if (isSmallScreen()) {
            iFrameConnection.sendToSDK(IFrameMessages.SCROLL_IFRAME_TOP);
        }
        if (forceRedraw) {
            this.redraw();
        }
    };

    onMount() {
        super.onMount();

        if (iFrameUserDataService.getActiveRecurringDonation()) {
            this.changeURL(DONATE_PAGE_URLS.recurringDonor, true);
        }
    }
}
